import { render } from "./TransferInfo.vue?vue&type=template&id=32239702&scoped=true"
import script from "./TransferInfo.vue?vue&type=script&lang=js"
export * from "./TransferInfo.vue?vue&type=script&lang=js"

import "./TransferInfo.vue?vue&type=style&index=0&id=32239702&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-32239702"

export default script